import React from "react";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";
import ClientModal from "../../common/ClientModal";
import UserModal from "../../common/UserModal";
import ClientQuotationModal from "../../common/ClientQuotationModal";
import styles from "./QuotationHeaderBar.module.scss";

const QuotationHeaderBar = ({
  quotationData,
  selectedClient,
  setSelectedClient,
  clientError,
  clientQuotations,
  openClientQuotationModal,
  selectedUser,
  setSelectedUser,
  userError,
  isParametersOpen,
  setIsParametersOpen,
  tableWidth,
  setTableWidth,
}) => {
  const nbLois = quotationData.quotations?.length || 0;
  const loisLabel =
    nbLois === 0
      ? "Aucune loi de roulage"
      : `${nbLois} loi${nbLois > 1 ? "s" : ""} de roulage`;
  const createdAt = quotationData.createdAt
    ? DateTime.fromISO(quotationData.createdAt).toFormat("dd/MM/yyyy")
    : null;

  return (
    <div className={styles.headerBar}>
      <div className={styles.identity}>
        <div className={styles.icon}>D</div>
        <div className={styles.titleGroup}>
          <h1>
            {quotationData.reference
              ? `Dossier ${quotationData.reference}`
              : "Nouveau dossier"}
          </h1>
          <div className={styles.subtitle}>
            {loisLabel}
            {createdAt && ` · créé le ${createdAt}`}
          </div>
        </div>
      </div>

      <div className={`${styles.controls} no-print`}>
        <div className={styles.selectorGroup}>
          <div className={styles.selectorRow}>
            <ClientModal
              selectedClient={selectedClient}
              selectClient={setSelectedClient}
              triggerClassName={selectedClient ? styles.pill : styles.pillEmpty}
            />
            {selectedClient && (
              <Link
                to={`/clients/${selectedClient.uuid}`}
                target="_blank"
                className={styles.roundBtn}
                title="Ouvrir la fiche client"
              >
                <i className="fa fa-external-link-alt" />
              </Link>
            )}
          </div>
          {clientError && <div className={styles.error}>{clientError}</div>}
        </div>

        <div className={styles.selectorGroup}>
          <div className={styles.selectorRow}>
            <UserModal
              selectedUser={selectedUser}
              selectUser={setSelectedUser}
              triggerClassName={selectedUser ? styles.pill : styles.pillEmpty}
            />
            {selectedUser && (
              <Link
                to={`/users/${selectedUser.uuid}`}
                target="_blank"
                className={styles.roundBtn}
                title="Ouvrir la fiche commercial"
              >
                <i className="fa fa-external-link-alt" />
              </Link>
            )}
          </div>
          {userError && <div className={styles.error}>{userError}</div>}
        </div>

        <div className={styles.separator} />

        <button
          type="button"
          className={styles.roundBtn}
          onClick={() => setIsParametersOpen((o) => !o)}
          aria-pressed={isParametersOpen}
          title="Tri et filtres"
        >
          <i className="fa fa-cog" />
        </button>

        <div className={styles.zoom}>
          <i className="fa fa-arrows-alt-h" /> {tableWidth}%
          <input
            min="100"
            max="200"
            step="1"
            value={tableWidth}
            onChange={(e) => setTableWidth(e.target.value)}
            type="range"
            className="form-control-range"
          />
        </div>
      </div>

      <ClientQuotationModal
        content={clientQuotations}
        openClientQuotationModal={openClientQuotationModal}
      />
    </div>
  );
};

export default QuotationHeaderBar;
